export default "__VITE_ASSET__BrPmu$i9__"